import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PulseLoader } from "react-spinners";
import RemoveIcon from "../../../assets/Times Circle.png";
import { Beneficiary } from "../../../types/beneficiaries";
import DatePicker from "../Input/Datepicker";
import Dropdown from "../Input/Dropdown";
import TextField from "../Input/Textfield";
import { useNameValidation } from "@/hooks/useNameValidation";
//import { Select } from "@WealthierAI/core";

interface AddBeneficiaryFormProps {
  index: number;
  showDeleteIcon: boolean;
  values: Beneficiary;
  onChange: (field: keyof Beneficiary, value: string) => void;
  onDelete: () => Promise<void>;
  isUserEnrolled?: boolean;
}

const relationshipOptions = [
  { label: "My Child", value: "Child" },
  { label: "My Grandchild", value: "Grandchild" },
  { label: "My Niece or Nephew", value: "NieceOrNephew" },
  { label: "Other", value: "Other" },
];

const AddBeneficiaryForm: React.FC<AddBeneficiaryFormProps> = ({
  index,
  showDeleteIcon,
  values,
  onChange,
  onDelete,
  isUserEnrolled,
}) => {
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    await onDelete();
    setIsDeleting(false);
  };

  const { errors, trigger, setValue } = useNameValidation({
    firstName: values.firstName,
    lastName: values.lastName,
  });

  const handleNameChange = async (
    field: "firstName" | "lastName",
    value: string,
  ) => {
    onChange(field, value);
    setValue(field, value);
    await trigger(field);
  };

  return (
    <>
      <div className="flex  justify-between items-center h-full">
        {!isUserEnrolled && (
          <h3 className="text-[18px] leading-[127%]">
            Beneficiary #{index + 1}
          </h3>
        )}
        {showDeleteIcon && (
          <div
            className="flex items-center cursor-pointer"
            onClick={handleDelete}
          >
            <img src={RemoveIcon} alt="RemoveIcon" />

            {isDeleting ? (
              <div className="px-1 flex items-center text-teal-500">
                <p className="text-sm pr-1">Deleting</p>
                <PulseLoader color="#14b8a6" size={8} />
              </div>
            ) : (
              <p className="px-1 text-teal-500">Remove</p>
            )}
          </div>
        )}
      </div>

      <div className="space-y-4">
        <div>
          <TextField
            name="firstName"
            label="First Name"
            value={values.firstName}
            onChange={(e) => handleNameChange("firstName", e.target.value)}
          />
          {errors.firstName && (
            <div className="text-red-500 text-sm mt-1 px-3">
              {errors.firstName.message}
            </div>
          )}
        </div>

        <div>
          <TextField
            name="lastName"
            label="Last Name"
            value={values.lastName}
            onChange={(e) => handleNameChange("lastName", e.target.value)}
          />
          {errors.lastName && (
            <div className="text-red-500 text-sm mt-1 px-3">
              {errors.lastName.message}
            </div>
          )}
        </div>

        {/*  <Select
          options={relationshipOptions}
          label="Relationship"
          value={values.relationship}
          onChange={(e) => onChange("relationship", e.target.value)}
          placeholder="Select Relationship"
          name="relationship"
        /> */}

        <DatePicker
          name="birthdate"
          label="Date of birth"
          value={values.dateOfBirth}
          onChange={(value) => onChange("dateOfBirth", value)}
          dateRestriction="past"
          // modalMode={isUserEnrolled}
          modalMode={true}
        />

        <Dropdown
          name="relationship"
          label="Relationship"
          showToolTip
          toolTipText={t("onboarding.beneficiaries.relationship_tooltip")}
          value={values.relationship}
          options={relationshipOptions}
          onChange={(e) => onChange("relationship", e.target.value)}
        />
      </div>
    </>
  );
};

export default AddBeneficiaryForm;
